import { answerLogicRules, createAnswerSchemaWithMixins } from '../answerSchemaFields';
import {
  createQuestionSchemaWithMixins,
  questionCardSortingAllowUncomplete,
  questionCardSortingType,
  questionCategoryForUnsortedCards,
  questionExclusive,
  questionFixedRandomizeAnswers,
  questionRandomizeAnswers,
  questionRequiresAnswer,
} from '../questionSchemaFields';
import { config } from './CardSortingCategoryPoll.config';

export const schema = createQuestionSchemaWithMixins({
  mixins: {
    questionRequiresAnswer,
    questionCardSortingAllowUncomplete,
    questionRandomizeAnswers,
    questionFixedRandomizeAnswers,
    questionExclusive,
    questionCardSortingType,
    questionCategoryForUnsortedCards,
  },
  type: config.name,
  answer: createAnswerSchemaWithMixins({
    mixins: { answerLogicRules },
  }),
});
